import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  tabsWrapper: {
    flexGrow: 1,
    width: '100%',
    '& > .MuiPaper-root': {
      backgroundColor: theme.palette.primary.lighter,
      color: theme.palette.common.white,
      '& button': {
        fontWeight: theme.typography.fontWeightSemiBold,
        '&:not(.Mui-selected)': {
          color: theme.palette.common.white
        }
      }
    },
    '& .MuiTabs-indicator': {
      height: 4
    }
  },
  FilterChip: {
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      marginLeft: theme.spacing(1),
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      '&.has-color': {
        display: 'flex'
      }
    }
  },
  cellDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& *': {
      maxWidth: 225,
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& span': {
      fontSize: theme.typography.pxToRem(12)
    }
  },
  modifyLink: {
    whiteSpace: 'nowrap',
    padding: theme.spacing(0),
    transition: 'all 0.3s ease-in-out',
    backgroundColor: 'transparent !important',
    fontWeight: theme.typography.fontWeightSemiBold,
    '&:hover': {
      color: theme.palette.secondary.main
    }
  },
  editBtn: {
    marginTop: theme.spacing(-1.5),
    marginBottom: theme.spacing(-1.5)
  },
  status: {
    '&.active': {
      color: theme.palette.success.main
    },
    '&.not-active': {
      color: theme.palette.error.main
    }
  },
  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.7,
    marginLeft: theme.spacing(0.375),
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(20)
    },
    '&.approved': {
      color: theme.palette.success.main
    },
    '&.rejected': {
      color: theme.palette.error.main
    },
    '&.submitted': {
      color: theme.palette.info.light
    }

  },
  codesBulkImport: {
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightSemiBold,
    fontSize: theme.typography.pxToRem(18)
  },
}))
